import {
  IAdminProgramCodeCreateNewPayload,
  IAdminProgramCodeDetails,
  IAdminProgramCodeEditPayload,
} from '@interfaces/adminProgramCodes';
import { IIdentity } from '@interfaces/common';

import { apiUrls } from './urls';
import { get, post, put } from './utils';

export const getAdminProgramCodeDetails = (programCodeId: number) =>
  get<IAdminProgramCodeDetails>(`${apiUrls.programCodes.details}/${programCodeId}`);

export const adminCreateNewProgramCode = (payload: IAdminProgramCodeCreateNewPayload) =>
  post<IIdentity>(apiUrls.programCodes.create, payload);

export const adminEditProgramCode = (payload: IAdminProgramCodeEditPayload) =>
  put(apiUrls.programCodes.update, payload);
